import gql from 'graphql-tag';
import React from 'react';
import { graphql, withApollo, compose } from 'react-apollo';
import { LegalFormalNoticeTemplate } from '../../../queries/LegalFormalNoticeTemplate';
import { CreateLegalFormalNotice } from '../../../mutations/CreateLegalFormalNotice';
import { assignedGroupsData } from '../../TaskCreator/assignData';

const TASK_QUERY = gql`
  query TASK_QUERY($id: ID!) {
    task(id: $id) {
      id
      priority
      claimId
      claim {
        id
        legalFormalNoticeTemplatePresection {
          groups {
            id
            label
          }
          options {
            id
            name
            group
            type
            values {
              value
              label
            }
            selected
          }
        }
      }
    }
  }
`;

const ACCEPT_LFN = gql`
  mutation acceptTask($input: AcceptLegalFormalNoticeMutationInput!) {
    acceptLegalFormalNotice(input: $input) {
      legalFormalNotice {
        id
      }
    }
  }
`;

const withTemplateQuery = WrappedComponent => ({
  client,
  history,
  ...props
}) => (
  <WrappedComponent
    {...props}
    acceptTask={(input, { onSuccess, onError }) => {
      client
        .mutate({
          mutation: ACCEPT_LFN,
          variables: { input }
        })
        .then(onSuccess)
        .catch(onError);
    }}
    submitSections={(input, { onSuccess, onError }) => {
      client
        .mutate({
          mutation: CreateLegalFormalNotice,
          variables: { input }
        })
        .then(onSuccess)
        .catch(onError);
    }}
    queryTemplates={(input, { onSuccess, onError }) => {
      client
        .query({
          query: LegalFormalNoticeTemplate,
          variables: input
        })
        .then(({ data: { claim } }) => {
          const templates = claim && claim.legalFormalNoticeTemplate;
          const { sectionsData, fullPaxFieldsData } = assignedGroupsData(
            templates
          );
          onSuccess({ sectionsData, fullPaxFieldsData });
        })
        .catch(onError);
    }}
  />
);

const withTaskQuery = graphql(TASK_QUERY, {
  options: ownProps => ({
    variables: {
      id: ownProps.task.id
    }
  }),
  props: ({ data: { task, loading, error } }) => ({
    error,
    loading,
    task,
    claim: task && task.claim
  })
});

export default WrappedComponent =>
  compose(
    withApollo,
    withTemplateQuery,
    withTaskQuery
  )(WrappedComponent);



// WEBPACK FOOTER //
// ./src/component/tasks/CreateLegalFormalNotice/withQueries.js